export default __webpack_public_path__ + "static/media/project_bg.d97d87b7.png";